import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';

import { Observable } from 'rxjs/Observable';
import { OAuthService } from 'angular-oauth2-oidc';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from '@ngx-config/core';
import { Store } from '@ngrx/store';

import { State } from '../../state-management/reducers';
import * as ApiKeysActions from '../../state-management/actions/api-key';
import { ApiKeysResponse } from './api-keys.model';

@Injectable()
export class ApiKeysService implements CanActivate {
	private _cache: ApiKeysResponse;

	public constructor(
		private _oauth: OAuthService,
		private _http: HttpClient,
		private _configService: ConfigService,
		private _store: Store<State>,
	) {}

	public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
		return this.loadKeys().switchMap(response => {
			this._store.dispatch(new ApiKeysActions.AddApiKeys(response));
			return Observable.of(true);
		}).catch(() => Observable.of(false));
	}

	public loadKeys(): Observable<ApiKeysResponse> {
		if (this._cache) {
			return Observable.of(this._cache);
		}

		const endpoint: string = this._configService.getSettings('apiKeys', 'endpoint').endpoint;

		const headers = new HttpHeaders()
			.set('Authorization', `Bearer ${this._oauth.getAccessToken()}`);

		return this._http.get<ApiKeysResponse>(endpoint, { headers })
			.do(response => this._cache = response);
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/services/api-keys/api-keys.service.ts